module.exports = __webpack_public_path__ + "img/aniversarios-quinto-thumbnail.4f55a05c.png";